import { Controller } from "@hotwired/stimulus";

const LIGHT_THEME = "zaproute";
const DARK_THEME = "zaproute-dark";
const STORAGE_KEY = "theme";

export default class extends Controller {
  static targets = ["lightIcon", "darkIcon"];

  connect() {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) document.documentElement.setAttribute("data-theme", stored);
    this.syncIcons();
  }

  toggle() {
    const isDark =
      document.documentElement.getAttribute("data-theme") === DARK_THEME;
    const next = isDark ? LIGHT_THEME : DARK_THEME;
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem(STORAGE_KEY, next);
    this.syncIcons();
  }

  syncIcons() {
    const isDark =
      document.documentElement.getAttribute("data-theme") === DARK_THEME;
    if (this.hasLightIconTarget)
      this.lightIconTarget.classList.toggle("hidden", isDark);
    if (this.hasDarkIconTarget)
      this.darkIconTarget.classList.toggle("hidden", !isDark);
  }
}
